import { makeStyles } from "@fluentui/react-components";
import { customTokens } from "../../theme/theme";

const useFooterStyles = makeStyles({
  footer: {
    backgroundColor: customTokens.UNFCCCPrimaryOcean100,
    // minHeight: "325px",
    padding: "48px 240px 180px 240px",

    "@media (max-width: 1440px)": {
      padding: "48px 120px 180px 120px",
    },

    "@media (min-width: 769px) and (max-width: 1024px)": {
      padding: "48px 64px 150px 64px",
      gap: "16px",
    },

    "@media (max-width: 768px)": {
      gap: "16px",
      padding: "32px 20px 150px 20px",
    },
  },

  column: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    width: "100%",
  },

  bottomContainer: {
    display: "flex",
    width: "100%",
  },

  linkWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },

  link: {
    cursor: "pointer",
    textDecoration: "underline",
  },

  socialLinkWrapper: {
    display: "flex",
    gap: "12px",
  },

  socialLinkMobileWrapper: {
    marginBottom: "16px",
  },

  socialLink: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "4px",
    borderRadius: "50%",
    border: `1px solid ${customTokens.colorNeutralBackground1}`,
    cursor: "pointer",
  },
});

export default useFooterStyles;
